// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userpfs i[data-v-5b2d5bb6]{margin:0 5px}.btn[data-v-5b2d5bb6]{color:#421eef;cursor:pointer}.ctn[data-v-5b2d5bb6]{border:1px solid #d4d4d4;height:100%;overflow:auto}.top[data-v-5b2d5bb6]{background:#f5f5f5;font-weight:550;text-align:left;padding-left:20px;line-height:40px}.top span[data-v-5b2d5bb6]{color:#999;font-size:12px;font-weight:400;margin-left:10px}", ""]);
// Exports
module.exports = exports;
